import React, { useState } from "react";
import { useSelector } from "react-redux";
import api from "../../helper/api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
    const { t } = useTranslation();
    const configData = useSelector((state) => state.config.data);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        description: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "subject" && value.trim().length > 150) return;
        if (name === "description" && value.trim().length > 1000) return;

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = formData
        payload.parent_id = configData._id

        console.log("Submitted Data:", payload);
        await api.post("contact-us", payload).then((res) => {
            toast.success(res.data.message)
        }).catch((error) => {
            console.log("error", error)
        })
        setFormData({
            name: "",
            email: "",
            subject: "",
            description: "",
        })
    };

    return (
        <div
            className="container d-flex justify-content-center align-items-center pt-4"
            style={{
                minHeight: "80vh",
                color: "var(--text-color)",
            }}
        >
            <div
                className="col-12 col-md-8 col-lg-6 p-4 rounded shadow-sm"
                style={{
                    backgroundColor: "var(--card-bg)",
                    boxShadow: `0 4px 12px var(--card-shadow)`,
                    margin: "auto",
                }}
            >
                <h2 className="text-center mb-4" style={{ color: "var(--primary-text)" }}>
                    {t("contactUs.header")}
                </h2>
                <form onSubmit={handleSubmit}>
                    {/* Name */}
                    <div className="mb-3">
                        <label className="form-label" style={{ color: "var(--text-color)" }}>
                            {t("contactUs.fullName")}
                        </label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder={t("contactUs.enterFullName")}
                            style={{
                                backgroundColor: "var(--input-bg)",
                                color: "var(--input-text)",
                                border: "1px solid var(--input-border)",
                            }}
                        />
                    </div>

                    {/* Email */}
                    <div className="mb-3">
                        <label className="form-label" style={{ color: "var(--text-color)" }}>
                            {t("contactUs.email")}
                        </label>
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder={t("contactUs.enterEmail")}
                            style={{
                                backgroundColor: "var(--input-bg)",
                                color: "var(--input-text)",
                                border: "1px solid var(--input-border)",
                            }}
                        />
                    </div>

                    {/* Subject */}
                    <div className="mb-3">
                        <label className="form-label" style={{ color: "var(--text-color)" }}>
                            {t("contactUs.subject")}
                        </label>
                        <input
                            type="text"
                            name="subject"
                            className="form-control"
                            value={formData.subject}
                            onChange={handleChange}
                            required
                            placeholder={t("contactUs.enterSubject")}
                            style={{
                                backgroundColor: "var(--input-bg)",
                                color: "var(--input-text)",
                                border: "1px solid var(--input-border)",
                            }}
                        />
                        <small style={{ color: "var(--secondary-text-color)" }}>
                            {formData.subject.trim().length}/150 characters
                        </small>
                    </div>

                    {/* Description */}
                    <div className="mb-3">
                        <label className="form-label" style={{ color: "var(--text-color)" }}>
                            {t("contactUs.description")}
                        </label>
                        <textarea
                            name="description"
                            className="form-control"
                            rows="5"
                            value={formData.description}
                            onChange={handleChange}
                            required
                            placeholder={t("contactUs.enterDescription")}
                            style={{
                                backgroundColor: "var(--input-bg)",
                                color: "var(--input-text)",
                                border: "1px solid var(--input-border)",
                            }}
                        />
                        <small style={{ color: "var(--secondary-text-color)" }}>
                            {formData.description.trim().length}/1000 characters
                        </small>
                    </div>

                    {/* Submit */}
                    <div className="d-grid">
                        <button
                            type="submit"
                            className="btn btn-primary btn-lg"
                            style={{
                                backgroundColor: "var(--color-purple-light)",
                                border: "none",
                                color: "var(--text-color-btn)",
                            }}
                            onMouseOver={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--color-purple)")
                            }
                            onMouseOut={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--color-purple-light)")
                            }
                        >
                            {t("contactUs.submit")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContactUs;
